import ApiClient from 'services/apiClient';

export const fetchBanners = async (lang: string) => {
  const response = await ApiClient.getInstance().get({
    url: '/common/getbanners',
    params: { lang: lang },
  });
  return response.data;
};

